/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordDeprecatedErrors } from './evidence-record-deprecated-errors';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordDeprecatedInvoiceIssuer } from './evidence-record-deprecated-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordDeprecatedUpdatedBy } from './evidence-record-deprecated-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordDeprecatedUploadedBy } from './evidence-record-deprecated-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordDeprecatedWarnings } from './evidence-record-deprecated-warnings';

/**
 * 
 * @export
 * @interface EvidenceRecordDeprecated
 */
export interface EvidenceRecordDeprecated {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'paymentType': EvidenceRecordDeprecatedPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'electronicMethod': EvidenceRecordDeprecatedElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'documentSize': EvidenceRecordDeprecatedDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'legalValidity': EvidenceRecordDeprecatedLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceRecordDeprecatedInvoiceIssuer}
     * @memberof EvidenceRecordDeprecated
     */
    'invoiceIssuer': EvidenceRecordDeprecatedInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'dpiError': EvidenceRecordDeprecatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'detectedDpiError': EvidenceRecordDeprecatedDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'calculatedDpiError': EvidenceRecordDeprecatedCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'colorGradationError': EvidenceRecordDeprecatedColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'heightMillisError': EvidenceRecordDeprecatedHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'widthMillisError': EvidenceRecordDeprecatedWidthMillisErrorEnum;
    /**
     * 
     * @type {EvidenceRecordDeprecatedErrors}
     * @memberof EvidenceRecordDeprecated
     */
    'errors': EvidenceRecordDeprecatedErrors;
    /**
     * 
     * @type {EvidenceRecordDeprecatedWarnings}
     * @memberof EvidenceRecordDeprecated
     */
    'warnings': EvidenceRecordDeprecatedWarnings;
    /**
     * 
     * @type {EvidenceRecordDeprecatedUpdatedBy}
     * @memberof EvidenceRecordDeprecated
     */
    'updatedBy': EvidenceRecordDeprecatedUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceRecordDeprecatedUploadedBy}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedBy': EvidenceRecordDeprecatedUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedAt': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedFrom': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'deleted': boolean;
}

export const EvidenceRecordDeprecatedPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidenceRecordDeprecatedPaymentTypeEnum = typeof EvidenceRecordDeprecatedPaymentTypeEnum[keyof typeof EvidenceRecordDeprecatedPaymentTypeEnum];
export const EvidenceRecordDeprecatedElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedElectronicMethodEnum = typeof EvidenceRecordDeprecatedElectronicMethodEnum[keyof typeof EvidenceRecordDeprecatedElectronicMethodEnum];
export const EvidenceRecordDeprecatedDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedDocumentSizeEnum = typeof EvidenceRecordDeprecatedDocumentSizeEnum[keyof typeof EvidenceRecordDeprecatedDocumentSizeEnum];
export const EvidenceRecordDeprecatedLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceRecordDeprecatedLegalValidityEnum = typeof EvidenceRecordDeprecatedLegalValidityEnum[keyof typeof EvidenceRecordDeprecatedLegalValidityEnum];
export const EvidenceRecordDeprecatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedDpiErrorEnum = typeof EvidenceRecordDeprecatedDpiErrorEnum[keyof typeof EvidenceRecordDeprecatedDpiErrorEnum];
export const EvidenceRecordDeprecatedDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedDetectedDpiErrorEnum = typeof EvidenceRecordDeprecatedDetectedDpiErrorEnum[keyof typeof EvidenceRecordDeprecatedDetectedDpiErrorEnum];
export const EvidenceRecordDeprecatedCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedCalculatedDpiErrorEnum = typeof EvidenceRecordDeprecatedCalculatedDpiErrorEnum[keyof typeof EvidenceRecordDeprecatedCalculatedDpiErrorEnum];
export const EvidenceRecordDeprecatedColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordDeprecatedColorGradationErrorEnum = typeof EvidenceRecordDeprecatedColorGradationErrorEnum[keyof typeof EvidenceRecordDeprecatedColorGradationErrorEnum];
export const EvidenceRecordDeprecatedHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedHeightMillisErrorEnum = typeof EvidenceRecordDeprecatedHeightMillisErrorEnum[keyof typeof EvidenceRecordDeprecatedHeightMillisErrorEnum];
export const EvidenceRecordDeprecatedWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedWidthMillisErrorEnum = typeof EvidenceRecordDeprecatedWidthMillisErrorEnum[keyof typeof EvidenceRecordDeprecatedWidthMillisErrorEnum];


